import { MovesEnum, RoundOutcome } from 'shared/constants/shared-enums';

export interface IPrizeBoxMainContentProps {
  loading: boolean;
  pool: number;
  phase: GamePhase;
  attemptsLeft: number;
  points: number;
  snapshotPoints: number;
  playerWins: number;
  aiWins: number;
  lastMoves: { playerAMove: MovesEnum; playerBMove: MovesEnum } | null;
  selectedMove: MovesEnum | null;
  aiMove: MovesEnum | null;
  lastRoundOutcome: RoundOutcome | null;
  quotaResetAt: number;
  extraCredits: number;
  recoveryAmount: number;
  result: any;
  closeResult: () => void;
  selectedMoveTopHand: any;
  error: string | null;
  currentSlotBalance: number;
}

export type PrizeBoxState = {
  loading: boolean;
  error: string | null;
  phase: GamePhase;
  selectedMove: MovesEnum | null;
  aiMove: MovesEnum | null;
  result: PrizeResult | null;
  playerWins: number;
  aiWins: number;
  lastMoves: { playerAMove: MovesEnum; playerBMove: MovesEnum } | null;
  lastRoundOutcome: RoundOutcome | null;
  pool: number; // cents
  points: number;
  quotaResetAt: number; // epoch ms
  extraCredits: number;
  snapshotPoints: number;
  currentSlotBalance: number;
  topHands: Record<MovesEnum, number> | null;
  recoveryAmount: number;
  loadingApprove?: boolean;
  needsAllowance?: boolean;
  attempts?: number;
  needsRestore?: boolean;
};

export enum HandTypes {
  Rock = 'rock',
  Paper = 'paper',
  Scissors = 'scissors',
}

export type HandType = HandTypes;

export enum GamePhase {
  Idle = 'idle',
  Selecting = 'selecting',
  Revealing = 'revealing',
  Result = 'result',
  Cooldown = 'cooldown',
}

export enum PrizeKind {
  Points = 'points',
  Money = 'money',
  Draw = 'draw',
  Lose = 'lose',
}

export enum RoundResult {
  Win = 'win',
  Draw = 'draw',
  Lose = 'lose',
}

export type WinStatus = RoundResult;

export type PrizeResult =
  | { kind: PrizeKind.Points; amount: number; status: WinStatus }
  | { kind: PrizeKind.Money; amount: number; totalAmount: number; status: WinStatus }
  | { kind: PrizeKind.Draw; amount: 0; status: WinStatus }
  | { kind: PrizeKind.Lose; amount: 0; status: WinStatus };

export interface IRaffleState {
  thresholdCents: number; // threshold in cents to trigger topHand changes
  windowStart: number; // epoch ms of the rolling window start
  quotaResetAt: number; // epoch ms when attempts reset (windowStart+24h)
  poolUsdt: number; // total token balance available (mocked)
  attempts: number; // attempts left in current window (max 10)
  currentSlotBalance: number; // current timeslot spend accumulator
  spendLimit: number; // spend limit per slot
  slotDurationSec: number; // slot duration in seconds
  lastSlotEndTime: number; // epoch ms for end of current slot
  extraCredits: number; // purchased attempts that bypass quota
  recoveryAmount: number; // price in cents for recovery amount
  needsRestore: boolean; // whether user needs to restore allowance
  contractReadable: boolean; // whether contract is readable (correct network, etc.)
}

export interface IPlayResponse {
  status: WinStatus;
  aiHand: HandType;
  pointsToWithdraw: number; // 10 (draw/lose) or 30 (win)
  winAmount: number; // USDT amount (0 if none)\
  totalAmount: number; // USDT amount (0 if none), including fallback
  addedPoints: number; // +50 when fallback, else 0
  state: IRaffleState; // updated state post-play
}
